module.exports = {
          srcSet: __webpack_public_path__ + "public/images/b0d34b8ec9f2eed1030829bfb83d914d-1774.webp"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/b0d34b8ec9f2eed1030829bfb83d914d-1774.webp",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/b0d34b8ec9f2eed1030829bfb83d914d-1774.webp",
          toString:function(){return __webpack_public_path__ + "public/images/b0d34b8ec9f2eed1030829bfb83d914d-1774.webp"},
          
          width: 1774,
          height: 887
        }